import { render, staticRenderFns } from "./TablaDetalleDesembolso.vue?vue&type=template&id=6176a579&scoped=true"
import script from "./TablaDetalleDesembolso.vue?vue&type=script&lang=js"
export * from "./TablaDetalleDesembolso.vue?vue&type=script&lang=js"
import style0 from "./TablaDetalleDesembolso.vue?vue&type=style&index=0&id=6176a579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6176a579",
  null
  
)

export default component.exports